import styled from 'styled-components';
import { rem } from 'polished';
import { ModalOfferExpiredStyled } from '../ModalOfferExpiredStyled';

export const ModalOfferExpiredStyledAC = styled(ModalOfferExpiredStyled)`
    
`;
